import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import Factor from "./Factor";
import Person from "../Person";
import Document from "./Document";
import Remittance from "./Remittance";
import DocumentGenrate from "./DocumentGenrate";
import InvoiceGenrate from "./InvoiceGenrate";
import FactorDone from "./FactorDone";
import { NavLink } from 'react-router-dom';
import Conflicts from "../Conflicts/Conflicts";

export default class Factors extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'factor',
            data: null,
            loading: true,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            filters: {
                filter: 0,
                type: props.Type,
                documentNumber: '',
                factorNumber: '',
                orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
                currentAnnual: this.isNull(props.CurrentAnnual) ? true : props.CurrentAnnual,
            },
            systemModuleId: 4,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            sort: '',
            menuId: 0,
            currentConflictId: null,
            conflicts: []
        };
        this.setMenuId(this.state.filters.type);

        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(type) {
        if (type === 1 || type === 6) this.state.menuId = 34;
        if (type === 2) this.state.menuId = 35;
        if (type === 3) this.state.menuId = 36;
        if (type === 4) this.state.menuId = 37;
        if (type === 5) this.state.menuId = 38;
        if (type === 7) this.state.menuId = 218;
        if (type === 8) this.state.menuId = 219;
        if (type === 9) this.state.menuId = 229;
        if (type === 10) this.state.menuId = 237;
        if (type === 11) this.state.menuId = 236;
        if (type === 12) this.state.menuId = 239;
        if (type === 13) this.state.menuId = 242;
        if (type === 14) this.state.menuId = 243;
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 1
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={1} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 1,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.setMenuId(this.state.filters.type);

        this.refreshData();
    }
    showRemittance(record) {
        this.removeKeyDown();
        if (!this.isNull(record.parentId))
            this.showComponents({ component: <Remittance IO={3} Caller={this} Id={record.parentId} /> });
        else
            this.showComponents({ component: <Remittance IO={record.io} Caller={this} Id={record.id} /> });
    }
    onDocumentGenrate() {
        this.removeKeyDown();
        this.showComponents({ component: <DocumentGenrate Caller={this} Type={this.state.filters.type} /> });
    }
    onInvoiceGenrate() {
        this.removeKeyDown();
        this.showComponents({ component: <InvoiceGenrate Caller={this} Type={this.state.filters.type} StuffSubUnitEnable={this.state.data.global.company.stuffSubUnitEnable} /> });
    }
    onFactorDone() {
        this.removeKeyDown();
        this.showComponents({ component: <FactorDone Caller={this} Type={this.state.filters.type} /> });
    }    
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Factor OrderingId={this.state.filters.orderingId} Type={this.state.filters.type} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Factor OrderingId={this.state.filters.orderingId} Type={this.state.filters.type} Caller={this} /> });
    }
    showPerson(id) {
        this.showComponents({ component: <Person Caller={this} Id={id} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {this.state.inline === false && <div className="nk-block-head-content">
                            {this.state.filters.type !== 9 && <h3 className="nk-block-title page-title">فهرست فاکتورها</h3>}
                            {this.state.filters.type === 9 && <h3 className="nk-block-title page-title">دفتر دریافتها</h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} فاکتور یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت فاکتور جدید</span>
                                            </a>
                                        </li>
                                        {this.state.inline === false && this.state.filters.type !== 9 && this.hasPermission(226) && <li>
                                            <a onClick={e => this.onDocumentGenrate()} className="hand btn btn-success"><span>صدور اسناد فاکتورهای قطعی</span></a>
                                        </li>}
                                        {this.state.inline === false && this.state.filters.type === 2 && <li>
                                            <a onClick={e => this.onInvoiceGenrate()} className="hand btn btn-success"><span>صدور صورتحساب فاکتورهای قطعی</span></a>
                                        </li>}
                                        {this.state.inline === false && this.state.filters.type !== 9 && this.hasPermission(225) && <li>
                                            <a onClick={e => this.onFactorDone()} className="hand btn btn-success"><span>قطعی کردن فاکتورهای پیش نویس</span></a>
                                        </li>}
                                        {this.state.inline === false && this.state.filters.type === 2 && <li>
                                            <NavLink to="/salefacortypes/" className="hand btn btn-success">انواع فاکتورهای فروش</NavLink>
                                        </li>}
                                        {this.state.inline === false && <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.inline === false && <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-success"><p>مجموع: {this.money(this.state.data.totalFactor)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>
                        {this.state.filters.type === 2 && <div className="nk-block-head-content">
                            <div className="nk-block-des text-warning"><p>مجموع صورتحسابها: {this.money(this.state.data.totalInvoice)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                        {this.state.filters.type === 2 && <div className="nk-block-head-content">
                            <div className="nk-block-des text-warning"><p>مجموع حواله ها: {this.money(this.state.data.totalRemittance)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                        {(this.state.filters.type === 1 || this.state.filters.type === 6) && <div className="nk-block-head-content">
                            <div className="nk-block-des text-warning"><p>مجموع رسیدها: {this.money(this.state.data.totalRemittance)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                        {this.state.filters.type === 2 && <div className="nk-block-head-content">
                            <div className="nk-block-des text-danger"><p>مغایرت با صورتحسابها: {this.money(this.state.data.totalFactor - this.state.data.totalInvoice)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                        {(this.state.filters.type === 1 || this.state.filters.type === 6) && <div className="nk-block-head-content">
                            <div className="nk-block-des text-danger"><p>مغایرت با رسیدها: {this.money(this.state.data.totalFactor - this.state.data.totalRemittance)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                        {this.state.filters.type === 2 && <div className="nk-block-head-content">
                            <div className="nk-block-des text-danger"><p>مغایرت با حواله ها: {this.money(this.state.data.totalFactor - this.state.data.totalRemittance)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>}
                    </div>
                </div>}
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="طرف حساب" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.factorNumber} onChange={e => this.state.filters.factorNumber = e.target.value} placeholder={this.state.filters.type === 9 ? "شماره" : "شماره فاکتور"} className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.documentNumber} onChange={e => this.state.filters.documentNumber = e.target.value} placeholder="شماره سند" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">فاقد فیلتر</option>
                                                    {(this.state.filters.type === 1 || this.state.filters.type === 6) && <option value="1">فاقد رسید</option>}
                                                    {this.state.filters.type === 2 && <option value="2">فاقد حواله</option>}
                                                    <option value="3">فاقد سند</option>
                                                    <option value="4">قطعی شده</option>
                                                    <option value="5">پیش نویس</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.sort} onChange={e => this.state.sort = e.target.value} className="form-control">
                                                    {this.state.filters.type !== 9 && <option value="">شماره فاکتور (نزولی)</option>}
                                                    {this.state.filters.type !== 9 && <option value="number">شماره فاکتور (صعودی)</option>}
                                                    {this.state.filters.type === 9 && <option value="">شماره (نزولی)</option>}
                                                    {this.state.filters.type === 9 && <option value="number">شماره (صعودی)</option>}
                                                    <option value="-date">جدید به قدیم</option>
                                                    <option value="date">قدیم به جدید</option>
                                                    {/*<option value="-docnumber">شماره سند (نزولی)</option>*/}
                                                    {/*<option value="docnumber">شماره سند (صعودی)</option>*/}
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ فاکتوری یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                            {this.state.filters.type !== 9 && <div className="nk-tb-col text-center"><span className="sub-text">عطف</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">سند</span></div>
                                            {(this.state.filters.type === 1 || this.state.filters.type === 6) && <div className="nk-tb-col text-center"><span className="sub-text">رسید</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">حواله</span></div>}
                                            {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">صورتحساب</span></div>}
                                            {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.filters.type !== 5 && <div className="nk-tb-col text-center"><span className="sub-text">فروشنده/خریدار</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            {this.state.filters.type !== 13 && this.state.filters.type !== 14 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>}
                                            {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && <div className="nk-tb-col text-center"><span className="sub-text">باقی مانده</span></div>}

                                            {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ ارزی</span></div>}
                                            {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <div className="nk-tb-col text-center"><span className="sub-text">باقی مانده ارزی</span></div>}

                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مرحله</span></div>
                                            {this.state.filters.currentAnnual === false && <div className="nk-tb-col text-center"><span className="sub-text">سال مالی</span></div>}

                                            {this.state.data.global.company.warehouseSystem === true && <div className="nk-tb-col text-center">
                                                {(this.state.filters.type === 1 || this.state.filters.type === 6) && <div className="nk-tb-col text-center"><span className="sub-text">نوع رسید</span></div>}
                                                {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">نوع حواله</span></div>}
                                            </div>}
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>) }
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.number}
                                                        </a>
                                                    </span>
                                                </div>
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">عطف: </span>
                                                    <span className="sub-text text-center">{record.number2}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">سند: </span>
                                                    {record.documents.map(rmt =>
                                                        <span className="sub-text text-center" style={{ marginLeft: "5px" }}><a onClick={e => this.showDocument(rmt.id)} className="text-primary txt-bold hand">{rmt.number}</a></span>
                                                    )}
                                                </div>
                                                {(this.state.filters.type === 1 || this.state.filters.type === 6) &&
                                                    <div className="nk-tb-col">
                                                        <span className="onlyMobile">رسید: </span>
                                                        {record.remittances.map(rmt =>
                                                            <span className="sub-text text-center" style={{ marginLeft: "5px" }}><a onClick={e => this.showRemittance(rmt)} className="text-primary txt-bold hand">{rmt.number}</a></span>
                                                        )}
                                                    </div>
                                                }
                                                {this.state.filters.type === 2 &&
                                                    <div className="nk-tb-col">
                                                        <span className="onlyMobile">حواله: </span>
                                                        {record.remittances.map(rmt =>
                                                            <span className="sub-text text-center" style={{ marginLeft: "5px" }}><a onClick={e => this.showRemittance(rmt)} className="text-primary txt-bold hand">{rmt.number}</a></span>
                                                        )}
                                                    </div>
                                                }
                                                {this.state.filters.type === 2 &&
                                                    <div className="nk-tb-col">
                                                        <span className="onlyMobile">صورتحساب: </span>
                                                        <span className="sub-text text-center">{record.lastInvoiceNumber > 0 && <NavLink to={"/invoices/?factorno=" + record.number} className="text-primary txt-bold hand">{record.lastInvoiceNumber}</NavLink>}</span>
                                                    </div>
                                                }
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.filters.type !== 5 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">فروشنده/خریدار: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.showPersonCard(record.personId)}>{record.personName}{this.isBlank(record.personNationalId) ? "" : " (" + record.personNationalId + ")"}</a>
                                                    </span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ: </span>
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>}
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">باقی مانده: </span>
                                                    <span className="sub-text text-center">{this.money(record.remain)}</span>
                                                </div>}
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ ارزی: </span>
                                                    <span className="sub-text text-center">{this.money(record.total2)}</span>
                                                </div>}
                                                {this.state.filters.type !== 13 && this.state.filters.type !== 14 && this.state.filters.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">باقی مانده ارزی: </span>
                                                    <span className="sub-text text-center">{this.money(record.remain2)}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">وضعیت: </span>
                                                    <span className="sub-text text-center">{record.statusString}</span>
                                                </div>
                                                {this.state.filters.type !== 9 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">مرحله: </span>
                                                    <span className="sub-text text-center">{record.workFlowStepName}</span>
                                                </div>}
                                                {this.state.filters.currentAnnual === false && <div className="nk-tb-col">
                                                    <span className="onlyMobile">سال مالی: </span>
                                                    <span className="sub-text text-center">{record.annualTitle}</span>
                                                </div>}
                                                {this.state.filters.type !== 9 && this.state.data.global.company.warehouseSystem === true && <div className="nk-tb-col">
                                                    {(this.state.filters.type === 1 || this.state.filters.type === 6) && <div className="nk-tb-col text-center"><span className="sub-text">نوع رسید</span></div>}
                                                    {this.state.filters.type === 2 && <div className="nk-tb-col text-center"><span className="sub-text">نوع حواله</span></div>}
                                                    <span className="sub-text text-center">{record.manualRemittance?"دستی":"خودکار"}</span>
                                                </div>}
                                                
                                                <div className="nk-tb-col text-end">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <em className="icon ni ni-pen"></em>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline === false && <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

            ];
        return contents;
    }
}